// extracted by mini-css-extract-plugin
module.exports = {"body":"placeholder-module__body___SYkr9"};